import React, { Component } from 'react';

class NewsletterSuccess extends Component {

  render() {
    return (
      <div className="Newsletter">
        <h3>ASHA Newsletter Signup</h3>
        <div className="alert alert-success">Thank you. You have successfully signed up for our newsletter.</div>
      </div>
    );
  }
}

export default NewsletterSuccess;
